import { cardLinkApiClient } from '@/src/card-linking/api-client/cardLinkApiClient'

const getEnrolledCards = async (payload: any) => {
    const [_key, { cardLinkSessionId }] = payload.queryKey

    const { data } = await cardLinkApiClient.get(
        `/partner-card-link/${process.env.NEXT_PUBLIC_CARD_LINK_COMPANY_ID}/card-link-session/enrolled-cards`,
        {
            headers: {
                'Card-Link-Session-ID': cardLinkSessionId,
            },
        }
    )
    return await data
}

export default getEnrolledCards
